import  { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import Image1 from "../../assets/hero1.png";
import Image2 from "../../assets/hero2.jpg";
import Image3 from "../../assets/hero3.jpg";
import image4 from "../../assets/hero4.jpg";
import Image5 from "../../assets/hero5.jpg";
import image6 from "../../assets/hero6.jpg";
const slides = [
  {
    id: 1,
    image: Image1,
    tag: "Asset Tracking",
    title: "Manage Your",
    highlight: "Assets with Ease",
    subtitle: "Track every asset from purchase to retirement. Know what you own, where it is, and when it needs attention — all in one place.",
    stat1: { value: "40%", label: "Less Downtime" },
    stat2: { value: "3x", label: "Faster Audits" },
    stat3: { value: "99.5%", label: "Asset Visibility" }
  },
  {
    id: 2,
    image: Image2,
    tag: "Complete Oversight",
    title: "Stay on Top of",
    highlight: "Every Asset You Own",
    subtitle: "From equipment to devices — track lifecycles, warranty dates, and conditions across your entire organization effortlessly.",
    stat1: { value: "10K+", label: "Assets Tracked" },
    stat2: { value: "70%", label: "Cost Savings" },
    stat3: { value: "100%", label: "Compliance" }
  },
  {
    id: 3,
    image: Image3,
    tag: "Maintenance Made Simple",
    title: "Keep Every Asset",
    highlight: "Running Smoothly",
    subtitle: "Schedule maintenance, get timely reminders, and make sure every asset is serviced and ready when you need it.",
    stat1: { value: "50+", label: "Asset Categories" },
    stat2: { value: "35%", label: "Maintenance Savings" },
    stat3: { value: "Zero", label: "Missed Schedules" }
  },
  {
    id: 4,
    image: image4,
    tag: "Team Coordination",
    title: "Empower Your",
    highlight: "Maintenance Team",
    subtitle: "Assign tasks, track progress, and coordinate your team — all from a single dashboard designed for collaboration.",
    stat1: { value: "85%", label: "On-Time Completion" },
    stat2: { value: "200+", label: "Teams Onboarded" },
    stat3: { value: "5x", label: "Productivity Boost" }
  },
  {
    id: 5,
    image: Image5,
    tag: "Asset Longevity",
    title: "Extend the Life of",
    highlight: "Your Equipment",
    subtitle: "Preventive maintenance, depreciation tracking, and timely servicing help your assets last longer and perform better.",
    stat1: { value: "25%", label: "Longer Asset Life" },
    stat2: { value: "60%", label: "Cost Reduction" },
    stat3: { value: "100%", label: "Audit Ready" }
  },
  {
    id: 6,
    image: image6,
    tag: "Smart Insights",
    title: "Make Smarter",
    highlight: "Decisions with Data",
    subtitle: "Visual dashboards, trend reports, and real-time alerts help you plan ahead and reduce unexpected costs.",
    stat1: { value: "60%", label: "Fewer Breakdowns" },
    stat2: { value: "Real-Time", label: "Monitoring" },
    stat3: { value: "24/7", label: "Uptime Tracking" }
  }
];

const HeroSection = () => {
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);

  const goTo = useCallback((idx) => {
    if (animating) return;
    setAnimating(true);
    setCurrent(idx);
    setTimeout(() => setAnimating(false), 700);
  }, [animating]);

  const next = useCallback(() => goTo((current + 1) % slides.length), [current, goTo]);
  const prev = useCallback(() => goTo((current - 1 + slides.length) % slides.length), [current, goTo]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(c => (c + 1) % slides.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const slide = slides[current];

  return (
    <section id="home" className="lp-hero">
      {slides.map((s, i) => (
        <div
          key={s.id}
          className={`lp-hero__bg-slide ${i === current ? "active" : ""}`}
          style={{ backgroundImage: `url(${s.image})` }}
        />
      ))}
      <div className="lp-hero__overlay" />

      <div className="lp-hero__inner">
        <div className="lp-hero__content" key={current}>
          <div className="lp-hero__badge">{slide.tag}</div>
          <h1 className="lp-hero__title">
            {slide.title} <span className="lp-gradient-text">{slide.highlight}</span>
          </h1>
          <p className="lp-hero__subtitle">{slide.subtitle}</p>

          <div className="lp-hero__buttons">
            <button className="lp-btn lp-btn--primary lp-btn--lg" onClick={() => navigate("/login")}>
              Get Started Free <FaArrowRight />
            </button>
            <button
              className="lp-btn lp-btn--outline lp-btn--lg"
              onClick={() => {
                const el = document.getElementById("how-it-works");
                if (el) el.scrollIntoView({ behavior: "smooth" });
              }}
            >
              See How It Works
            </button>
          </div>

          <div className="lp-hero__stats">
            <div className="lp-hero__stat">
              <strong>{slide.stat1.value}</strong>
              <span>{slide.stat1.label}</span>
            </div>
            <div className="lp-hero__stat-divider" />
            <div className="lp-hero__stat">
              <strong>{slide.stat2.value}</strong>
              <span>{slide.stat2.label}</span>
            </div>
            <div className="lp-hero__stat-divider" />
            <div className="lp-hero__stat">
              <strong>{slide.stat3.value}</strong>
              <span>{slide.stat3.label}</span>
            </div>
          </div>
        </div>
      </div>

      <button className="lp-hero__arrow lp-hero__arrow--left" onClick={prev}>
        <FaChevronLeft />
      </button>
      <button className="lp-hero__arrow lp-hero__arrow--right" onClick={next}>
        <FaChevronRight />
      </button>

      <div className="lp-hero__dots">
        {slides.map((_, i) => (
          <button
            key={i}
            className={`lp-hero__dot ${i === current ? "active" : ""}`}
            onClick={() => goTo(i)}
          />
        ))}
      </div>

      <div className="lp-hero__counter">
        <span className="lp-hero__counter-current">{String(current + 1).padStart(2, "0")}</span>
        <span className="lp-hero__counter-sep">/</span>
        <span className="lp-hero__counter-total">{String(slides.length).padStart(2, "0")}</span>
      </div>
    </section>
  );
};

export default HeroSection;
